module.exports = __webpack_public_path__ + "media/images/logo_vitislife-65cf23bc.png";